import { Chip } from "@mui/material";
import { useCompanyDocumentsLanguage } from "../i18n/CompanyDocumentsLanguageContext";

const statuses = {
  MISSING: ["missing", "default"],
  SUBMITTED: ["submitted", "info"],
  VERIFIED: ["verified", "success"],
  NEED_REVISION: ["needRevision", "warning"],
  APPROVED: ["approved", "success"],
  REJECTED: ["rejected", "error"],
};

export default function DocumentStatus({ status }) {
  const { t } = useCompanyDocumentsLanguage();

  const [key, color] =
    statuses[status] || ["unavailable", "default"];

  return (
    <Chip
      size="small"
      variant="outlined"
      label={t(
        `client.documents.status.${key}`,
      )}
      color={color}
    />
  );
}
